import axios from 'axios';
import type { QueuePreferences } from 'Router/pages/AnsweringPages/AnsweringQueue/types';

const getQueuePreferences = async (): Promise<QueuePreferences> => {
  const { data } = await axios.get<QueuePreferences>(
    '/answering/queue_preferences',
  );
  return data;
};

export default getQueuePreferences;
